import React from 'react';

export default function HackingSectionCallToAction10() {
    return (
        <React.Fragment>
            <>
                <section className="py-20 bg-black">  <div className="container px-4 mx-auto">    <div className="flex flex-wrap items-center">            <div className="max-w-2xl mb-14 mx-auto text-center">        <h2 className="mb-6 text-4xl font-bold text-white">因为那些妄想改变世界的人，<br />正在改变世界。</h2>        <p className="mb-6 text-lg text-gray-50">The only thing keeping us from Liberty is a few more ideas.</p>            </div>              </div></div></section>


            </>
        </React.Fragment>
    );
}

